import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { FaTiktok } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/logo.jpg" alt="Kothu Rotti" className="footer-logo" />
            <p className="footer-tagline">SRILANKAN & INDIAN SPICY AROMA RESTAURANT</p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <div className="footer-links">
              <a href="#about" className="footer-link">About Us</a>
              <a href="#menu" className="footer-link">Menu</a>
              <a href="#combos" className="footer-link">Combos</a>
              <a href="#gallery" className="footer-link">Gallery</a>
              <a href="#locations" className="footer-link">Locations</a>
              <a href="#contact" className="footer-link">Contact</a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact Info</h3>
            <div className="footer-info">
              <p>427 St George's Rd, Glasgow G3 6JX</p>
              <p>106 Queen Margaret Drive, Glasgow G20 8N</p>
              <a href="tel:0141 378 3469" className="footer-link">0141 378 3469</a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Follow Us</h3>
            <div className="social-links">
              <a 
                href="https://www.instagram.com/kothu4u?igsh=MXJjbDl1d2Z3MXAxbQ==" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link hover-scale"
              >
                <Instagram size={24} />
              </a>
              <a 
                href="https://m.facebook.com/profile.php?id=61577777229085&name=xhp_nt__fb__action__open_user" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link hover-scale"
              >
                <Facebook size={24} />
              </a>
              <a 
                href="https://www.tiktok.com/@kothu4u?_r=1&_t=ZN-92aM5xXojzy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link hover-scale"
              >
                <FaTiktok size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2026 Kothu Rotti. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
